import React, { useContext, useEffect } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { generateSAMLLoginURL } from '../../utilities/saml';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isTokenValid, logout } = useContext(AuthContext);

  useEffect(() => {
    if (!isAuthenticated || !isTokenValid()) {
      if (isAuthenticated && !isTokenValid()) {
        // Token expired, logout and redirect
        logout();
      } else {
        // Not authenticated, redirect to SSO with dynamic SAML URL
        const loginUrl = generateSAMLLoginURL();
        if (loginUrl) {
          window.location.href = loginUrl;
        }
      }
    }
  }, [isAuthenticated, isTokenValid, logout]);

  // Show nothing while redirecting
  if (!isAuthenticated) {
    return null;
  }

  return children;
};

export default ProtectedRoute;
